import i18n from '@/utils/i18n'

export default {
  path: '/p', // member-en entry all file
  component: () => import(/* webpackChunkName: "about" */ '../views/entry'),
  children: [
    {
      path: 'deposit', // 入金
      name: 'publicDeposit',
      meta: {
        title: i18n.t('index5') // '入金'
      },
      component: () =>
        import(
          /* webpackChunkName: "Deposit" */
          '../views/public/deposit'
        )
    },
    {
      path: 'withdrawal',
      name: 'publicWithdrawal',
      meta: {
        title: i18n.t('index6') //  '出金'
      },
      component: () =>
        import(
          /* webpackChunkName: "withdrawal" */
          '../views/public/withdrawal'
        )
    },
    {
      path: 'deposit-record', // 入金记录
      name: 'publicDepositRecord',
      meta: {
        title: i18n.t('my5') //   '入金记录'
      },
      component: () =>
        import(
          /* webpackChunkName: "DepositRecord" */
          '../views/public/records/depositRecord.vue'
        )
    },
    {
      path: 'withdrawal-record', // 出金记录
      name: 'publicWithdrawalRecord',
      meta: {
        title: i18n.t('my45') //    '出金记录'
      },
      component: () =>
        import(
          /* webpackChunkName: "WithdrawalRecord" */
          '../views/public/records/withdrawalRecord.vue'
        )
    },
    {
      path: 'down', // 基础信息
      name: 'down',
      meta: {
        title: '下载'
      },
      component: () =>
        import(
          /* webpackChunkName: "UserInfo" */
          '../views/public/down/index.vue'
        )
    },
    {
      path: 'message', // 站内信
      name: 'message',
      meta: {
        title: '站内信' //   '站内信'
      },
      component: () =>
        import(
          /* webpackChunkName: "message" */
          '../views/public/message/index.vue'
        )
    }
  ]
}
